import React, { useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  MenuItem,
  Snackbar,
  Alert,
} from '@mui/material';
import './Signup.css';

const Signup = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    confirmPassword: '',
    role: ''
  });
  const [alert, setAlert] = useState({ open: false, type: 'success', message: '' });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSignup = async () => {
    const { username, password, confirmPassword, role } = formData;

    if (!username || !password || !confirmPassword || !role) {
      return setAlert({ open: true, type: 'error', message: 'All fields are required' });
    }

    if (password !== confirmPassword) {
      return setAlert({ open: true, type: 'error', message: 'Passwords do not match' });
    }

    setLoading(true);

    try {
      const res = await fetch('https://core-bankers-backend.vercel.app/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password, role })
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Signup failed');

      localStorage.setItem("token", data.token);
  localStorage.setItem("refreshToken", data.refreshToken);
  localStorage.setItem("role", role);

  setAlert({ open: true, type: "success", message: data.message || "Signup successful" });
   
  // 👇 redirect after slight delay
  setTimeout(() => {
    window.location.href = "/create-account";
  }, 1000);

    } catch (err) {
      setAlert({ open: true, type: 'error', message: err.message });
    }
  };

  return (
    <Container maxWidth="sm">
      <Paper className="signup-card">
        <Typography variant="h5" className="signup-title">
          Create Your Account
        </Typography>

        <TextField
          fullWidth
          name="username"
          label="Username"
          value={formData.username}
          onChange={handleChange}
          variant="outlined"
          className="signup-field"
        />

        <TextField
          fullWidth
          name="password"
          label="Password"
          type="password"
          value={formData.password}
          onChange={handleChange}
          variant="outlined"
          className="signup-field"
        />

        <TextField
          fullWidth
          name="confirmPassword"
          label="Confirm Password"
          type="password"
          value={formData.confirmPassword}
          onChange={handleChange}
          variant="outlined"
          className="signup-field"
        />

        <TextField
          select
          fullWidth
          name="role"
          label="Select Role"
          value={formData.role}
          onChange={handleChange}
          className="signup-field"
        >
          <MenuItem value="client">Customer</MenuItem>
          <MenuItem value="sub_dsa">Sub DSA</MenuItem>
        </TextField>

        <Button
  fullWidth
  variant="contained"
  color="primary"
  className="signup-button"
  onClick={handleSignup}
  disabled={loading}
>
  {loading ? "Signing up..." : "Sign Up"}
</Button>

        <Typography className="signin-text">
          Already have an account? <a href="/login">Login here</a>
        </Typography>
      </Paper>

      <Snackbar
        open={alert.open}
        autoHideDuration={3000}
        onClose={() => setAlert({ ...alert, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity={alert.type} variant="filled">
          {alert.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Signup;